import { http } from '../helpers/axiosHelper';
export default class PowerBiService {
   async getAccessToken() {
      return await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/power-bi/access-token').then((response) => {
         return response.data;
      });
   }
}
